import { render, staticRenderFns } from "./userbankcard-add-or-update.vue?vue&type=template&id=655f053d&"
import script from "./userbankcard-add-or-update.vue?vue&type=script&lang=js&"
export * from "./userbankcard-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports